import {
  ACCOUNT_TYPE_LABELS,
  ACCOUNT_TYPE_ICONS,
  ACCOUNT_TYPE_UNSPECIFIED,
  ACCOUNT_TYPE_UNSPECIFIED_LABEL,
} from './AccountList.constants';
import { toTitleCase } from '../../../../../../libs/strings/strings';

export function formatAccountType(type) {
  if (!type || type === ACCOUNT_TYPE_UNSPECIFIED) return ACCOUNT_TYPE_UNSPECIFIED_LABEL;

  return ACCOUNT_TYPE_LABELS[type] || toTitleCase(type);
}

export function getAccountTypeIcon(type) {
  return ACCOUNT_TYPE_ICONS[type] || ACCOUNT_TYPE_ICONS.ACCOUNT_TYPE_UNSPECIFIED;
}
